import { whiteColor, primaryColor, hexToRgb } from 'assets/jss/material-dashboard-pro-react';

const departmentDetailsStyle = (theme) => ({
	cardIcon: {
		color: whiteColor,
	},
	editButton: {
		cursor: 'pointer',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		width: '40px',
		height: '40px',
		transition: 'all .1s ease-in-out',
		borderRadius: '4px',
		marginLeft: '6px',
		color: primaryColor[0],
		'&:hover': {
			backgroundColor: `rgba(${hexToRgb(primaryColor[0])}, 0.2)`,
		},
		'&:active': {
			backgroundColor: `rgba(${hexToRgb(primaryColor[0])}, 0.3)`,
		},
	},
	cardBody: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'flex-start',
		paddingRight: '55px',
		[theme.breakpoints.down('xs')]: {
			flexDirection: 'column',
			justifyContent: 'flex-start',
			paddingRight: '20px',
			'& > div:first-of-type': {
				marginBottom: '20px',
			},
		},
	},
	nameBlock: {
		display: 'flex',
		alignItems: 'flex-end',
		'& p': {
			marginBottom: 0,
		},
	},
	numbers: {
		display: 'flex',
	},
	managers: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		marginTop: '25px',
		[theme.breakpoints.down('xs')]: {
			flexDirection: 'column',
			justifyContent: 'flex-start',
			alignItems: 'flex-start',
			'& > button': {
				marginTop: '20px',
			},
		},
	},
	withoutMarginBottom: {
		marginBottom: 0,
	},
	managersWrapper: {
		marginTop: '8px',
	},
	usersWrapper: {
		marginTop: '48px',
	},
	dialogBody: {
		maxWidth: '288px',
		margin: '0 auto',
		paddingTop: '10px',
		paddingBottom: '20px',
		[theme.breakpoints.down('xs')]: {
			width: '80%',
			paddingTop: '5px',
		},
	},
	colorsCaption: {
		marginTop: '15px',
	},
	addManagerDialogBody: {
		width: '288px',
		maxWidth: '80%',
		margin: '0 auto',
		marginTop: '24px',
	},
	managersCaption: {
		marginTop: '32px',
		marginBottom: '8px',
	},
	manager: {
		height: '140px',
		overflowY: 'auto',
		marginTop: '16px',
	},
	dialogManagers: {
		height: '140px',
		overflowY: 'auto',
		marginTop: '16px',
	},
	dialogManager: {
		padding: '8px 8px 6px 8px',
		backgroundColor: `rgba(${hexToRgb(primaryColor[0])}, .5)`,
		display: 'inline-flex',
		alignItems: 'center',
		borderRadius: '16px',
		marginBottom: '8px',
		marginRight: '2px',
		cursor: 'pointer',
		userSelect: 'none',
		'& p': {
			marginBottom: 0,
			marginRight: '2px',
		},
		'& div svg': {
			width: '16px',
			height: 'auto',
			marginBottom: '2px',
			display: 'none',
			'&:nth-of-type(1)': {
				display: 'block',
				color: primaryColor[0],
			},
			'&:nth-of-type(2)': {
				color: whiteColor,
			},
			'&:nth-of-type(3)': {
				color: whiteColor,
			},
		},
	},
	selectedManager: {
		backgroundColor: primaryColor[0],
		'& p': {
			color: whiteColor,
		},
		'& div svg': {
			'&:nth-of-type(1)': {
				display: 'none',
			},
			'&:nth-of-type(2)': {
				display: 'block',
			},
			'&:nth-of-type(3)': {
				display: 'none',
			},
		},
		'&:hover': {
			opacity: 0.88,
			'& div svg': {
				'&:nth-of-type(2)': {
					display: 'none',
				},
				'&:nth-of-type(3)': {
					display: 'block',
				},
			},
		},
	},
	expirationDateWrapper: {
		marginTop: '32px',
		height: '400px',
		'& > div': {
			display: 'flex',
			justifyContent: 'space-between',
			alignItems: 'flex-end',
		},
		'& > label': {
			marginBottom: '4px',
		},
	},
	permissionsCell: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'flex-end',
		'& > div': {
			'& button': {
				margin: '2px 0 2px 4px',
				paddingTop: 0,
				paddingBottom: '2px',
			},
			'& svg': {
				marginRight: 0,
			},
		},
		'& p': {
			marginBottom: 0,
			position: 'relative',
			bottom: '-1px',
		},
	},
});

export default departmentDetailsStyle;
